/* eslint-disable */
import createIcon from '../createIcon';

const IconRightOutlined = createIcon({
  name: 'icon-right-outlined',
  content: '<path d="M702.208 512.319l-315.42-315.42-45.242 45.242 270.178 270.178-270.178 270.178 45.242 45.242 315.42-315.42z"/>',
  width: 1024,
  height: 1024
});
export default IconRightOutlined;
